export default "__VITE_ASSET__DP8P2Iuj__"